// extracted by mini-css-extract-plugin
module.exports = {"chartCustomAxisTick":"CustomYAxisTick_chartCustomAxisTick__lRMfB"};